import React from "react";
import { Popup } from "react-map-gl/mapbox";

import styles from "./waterFeaturePopup.module.css";

const popupStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#0b65c2",
};

export default function WaterFeaturePopup({ feature }) {
  if (!feature) {
    return null;
  }

  return (
    <Popup
      longitude={feature.longitude}
      latitude={feature.latitude}
      closeButton={false}
      closeOnClick={false}
      anchor="bottom"
      maxWidth="300px"
      className={styles.popup}
    >
      <div style={popupStyle}>{feature.name}</div>
    </Popup>
  );
}
